import React, {FunctionComponent} from 'react'
import styles from './TaskChecklist.module.sass'

interface Props {
    className: string
    content: string
}

const TaskChecklist: FunctionComponent<Props> = props => {

    let text = props.content
    text = text.replace(/\n/g, '<br />')
    return <div className={props.className}>
        <div className={styles.wrapper}>
            <div className={styles.header}>Заполните чек-лист:</div>
            <div className={styles.content} dangerouslySetInnerHTML={{__html: text}}>

            </div>
        </div>
    </div>
}

export default TaskChecklist